var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQualiteLocal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.66675 8H29.3334V13.3333L28.4014 13.8933C27.6761 14.3285 26.8462 14.5584 26.0004 14.5584C25.1546 14.5584 24.3247 14.3285 23.5994 13.8933L22.6667 13.3333L21.7347 13.8933C21.0095 14.3285 20.1796 14.5584 19.3337 14.5584C18.4879 14.5584 17.658 14.3285 16.9327 13.8933L16.0001 13.3333L15.0681 13.8933C14.3428 14.3285 13.5129 14.5584 12.6671 14.5584C11.8213 14.5584 10.9914 14.3285 10.2661 13.8933L9.33341 13.3333L8.40075 13.8933C7.67555 14.3284 6.84576 14.5582 6.00008 14.5582C5.1544 14.5582 4.32461 14.3284 3.59941 13.8933L2.66675 13.3333V8Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.3335 14.9927V29.3333H26.6668V14.6667M5.3335 7.88133V2.66666H26.6668V8",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6667 21.3333H19.3334V29.3333H12.6667V21.3333Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQualiteLocal);
export default __webpack_public_path__ + "static/media/qualite_local.8cca4c235373f5cee4acfcc40bfd2007.svg";
export { ForwardRef as ReactComponent };